package fr.frux.core.common.auth

/**
 * Thrown when the API rejects a request with 401 Unauthorized.
 * Lets upper layers distinguish an invalid/expired session from
 * network failures without depending on the HTTP client.
 */
class UnauthorizedException(message: String = "Unauthorized") : Exception(message)
